import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    alojamentos: [
      { name: 'Apartamento 1 - T0', path: '/apartamento-1' },
      { name: 'Apartamento 2 - T0', path: '/apartamento-2' },
      { name: 'Apartamento 3 - T0', path: '/apartamento-3' },
      { name: 'Apartamento 4 - T2 Premium', path: '/apartamento-4' },
    ],
    explorar: [
      { name: 'Experiências na Madeira', path: '/experiencias' },
      { name: 'Sobre Nós', path: '/sobre' },
      { name: 'Contactos', path: '/contactos' },
    ],
    suporte: [
      { name: 'FAQ', path: '/faq' },
      { name: 'Política de Cancelamento', path: '/politica-cancelamento' },
      { name: 'Termos e Condições', path: '/termos' },
    ],
    legal: [
      { name: 'Privacidade', path: '/privacidade' },
      { name: 'Livro de Reclamações', path: '/reclamacoes' },
    ],
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-white font-bold text-sm uppercase mb-4 tracking-wide">
              Alojamentos
            </h4>
            <div className="h-0.5 w-12 bg-sea-blue mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.alojamentos.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase mb-4 tracking-wide">
              Explorar
            </h4>
            <div className="h-0.5 w-12 bg-sea-blue mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.explorar.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase mb-4 tracking-wide">
              Suporte
            </h4>
            <div className="h-0.5 w-12 bg-sea-blue mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.suporte.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase mb-4 tracking-wide">
              Legal
            </h4>
            <div className="h-0.5 w-12 bg-sea-blue mb-6"></div>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-white transition-colors text-sm cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/46d54fb9-4fce-4c4d-b3cf-25c9c85dceea.png" 
                alt="Seaview & Levada Escape" 
                className="h-10 w-auto"
              />
              <div className="text-center md:text-left">
                <div className="text-sm text-slate-400">Madeira, Portugal</div>
              </div>
            </div>

            <div className="text-center md:text-right">
              <p className="text-sm text-slate-400 mb-3">
                © {currentYear} Seaview & Levada Escape. Todos os direitos reservados.
              </p>
              <div className="flex items-center justify-center md:justify-end space-x-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-800 text-slate-300 hover:bg-sea-blue hover:text-white transition-all cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-800 text-slate-300 hover:bg-sea-blue hover:text-white transition-all cursor-pointer"
                  aria-label="Facebook"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://wa.me/351912345678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-800 text-slate-300 hover:bg-sea-blue hover:text-white transition-all cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;